import { AxiosInstance } from 'axios'

import { EmployeeDependent } from '@modules/employees/types/EmployeesDependents/dependents'
import {
  CreateDependentRequest,
  DeleteDependentRequest,
  FindDependentsByEmployeeIdRequest,
  UpdateDependentRequest,
  UploadDependentBirthCertificateRequest,
} from '@modules/employees/types/EmployeesDependents/requests'

export class EmployeesDependentsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateDependentRequest): Promise<EmployeeDependent[]> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/dependents`, body)

    return response.data
  }

  async delete(data: DeleteDependentRequest): Promise<void> {
    const { dependentId, employeeId } = data

    await this.instance.delete(`/companies/employees/${employeeId}/dependents/${dependentId}`)
  }

  async find(data: FindDependentsByEmployeeIdRequest): Promise<EmployeeDependent[]> {
    const { employeeId } = data

    const response = await this.instance.get(`/companies/employees/${employeeId}/dependents`)

    return response.data
  }

  async update(data: UpdateDependentRequest): Promise<EmployeeDependent> {
    const { dependentId, employeeId, ...body } = data

    const response = await this.instance.put(`/companies/employees/${employeeId}/dependents/${dependentId}`, body)

    return response.data
  }

  async uploadBirthCertificate(data: UploadDependentBirthCertificateRequest): Promise<EmployeeDependent> {
    const { dependentId, employeeId, file } = data

    const formData = new FormData()
    formData.append('file', file)

    const url = `/companies/employees/${employeeId}/dependents/${dependentId}/birth-certificate`

    const response = await this.instance.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesDependentsService = (instance: AxiosInstance) => new EmployeesDependentsService(instance)
